export class ValidationPatterns{
    public static integer: string = '^[0-9]+$';

    public static doubleNumber: string = '^[0-9]+([,.][0-9]{1,2})?$';
}


// WEBPACK FOOTER //
// ./app/common/helpers/ValidationPatterns.ts